import { defineStore } from "pinia";
import {ref, watch} from "vue";
import * as CmsService from "@/services/cms.service";
import {useLocalization} from "@/locales/localization";

export const useCharterStore = defineStore('charterStore', () => {
    const charterBundles = ref([]); 
    const loadingCharters = ref(false);
    const { currentLocale } = useLocalization();


    function fetchCharterBundles() {
        loadingCharters.value = true;
        CmsService.getCharterBundles(currentLocale.value)
            .then((response) => {
                charterBundles.value = response.data; // Assign response data
            })
            .catch((error) => {
                console.error("Error fetching charter bundles:", error);
                charterBundles.value = [];
            })
            .finally(() => {
                loadingCharters.value = false; 
            });
    }

    watch(currentLocale, (newLocale, oldLocale) => {
        if (newLocale !== oldLocale) {
            fetchCharterBundles();
        }
    });

    return {
        charterBundles,
        loadingCharters,
        fetchCharterBundles,
    };
});